import { Reducer } from 'redux';
import AuthenticationReducerActionsTypes, {
  SET_PROFILE,
  SIGN_OUT,
} from './authenticationActions/authenticationActions.types';
import AuthenticationReducerState from './authenticationReducer.types';
import AUTHENTICATION_REDUCER_INITIAL_STATE from './authenticationReducerInitialState';

const authenticationReducer: Reducer<
  AuthenticationReducerState,
  AuthenticationReducerActionsTypes
> = (state = AUTHENTICATION_REDUCER_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_PROFILE: {
      return {
        ...state,
        profile: action.profile,
      };
    }

    case SIGN_OUT: {
      return AUTHENTICATION_REDUCER_INITIAL_STATE;
    }

    default: {
      return state;
    }
  }
};

export default authenticationReducer;
